export * from '@s20/common/constants/tenant';

export const TimesheetResponsibilityType = {
    CrewLead: 1,
    Individual: 2,
    Contract: 3,
};

export const ContractTimesheetResponsibilityType = {
    CrewLead: 1,
    Individual: 2,
};

export const CountyCaptureType = {
    None: 1,
    AllTimesheets: 2,
    PrevailingWageTimesheets: 3,
    UnionTimesheets: 4,
};

export const PayrollAppTypes = {
    None: 1,
    Paychex: 2,
    ADP: 3,
};

export const PayrollAppTypeOptions = [
    { value: 1, label: 'None' },
    { value: 2, label: 'Paychex' },
    { value: 3, label: 'ADP' },
];

// 2022-08-16 - M. Nicol - Moved to TenantForm.js > getTimesheetResponsibilityTypeOptions method to account for localized strings.
// export const TimesheetResponsibilityTypeOptions = [
//    {
//        id: 1,
//        name: 'Crew Lead',
//        description: 'Crew Leads are responsible for all timesheet entry.',
//    },
//    {
//        id: 2,
//        name: 'Individual',
//        description: 'Individual employees enter timesheets.',
//    },
//    {
//        id: 3,
//        name: 'Contract',
//        description:
//            'Timesheet responsibility is decided between individual/Crew Lead on a contract-by-contract basis.',
//    },
// ];

// 2022-08-16 - M. Nicol - Moved to TenantForm.js > getTimesheetResponsibilityTypeOptions method to account for localized strings.
// export const ContractTimesheetResponsibilityTypeOptions = [
//    {
//        id: 1,
//        name: 'Crew Lead',
//        description: 'Crew Leads are responsible for all timesheet entry.',
//    },
//    {
//        id: 2,
//        name: 'Individual',
//        description: 'Individual employees enter timesheets.',
//    },
// ];

export const isCountyCaptureEnabled = (tenantSettings) => Boolean(
    (tenantSettings.captureCounty == CountyCaptureType.AllTimesheets
            || tenantSettings.captureCounty == CountyCaptureType.PrevailingWageTimesheets
            || tenantSettings.captureCounty == CountyCaptureType.UnionTimesheets)
        && tenantSettings.googleMapsApiKey
        && tenantSettings.googleMapsApiKey.length > 0,
);
